/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFreightMatchingProfileDataOutput.ts  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/freight-matching-profile-data-output";

export class AutogenModelFreightMatchingProfileDataOutput<RowType extends ModelRow> extends Endpoint<RowType, RowFreightMatchingProfileDataOutputFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFreightMatchingProfileDataOutput extends ModelRow<RowFreightMatchingProfileDataOutputFields> {
	constructor(values?: Partial<RowFreightMatchingProfileDataOutputFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFreightMatchingProfileDataOutputFields {
	company_id: string;
	data_type: string;
	field_name: string;
	fm_profile_id: string;
	is_active: string;
	is_historical: string;
	listener_enabled: string;
	monitor: string;
	table_name: string;
}

